import React, { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { validateBidAdjustment } from '@bingads-webui-campaign/hotel-common-targets';
import { MultimediaAdBidAdjustmentSettings } from './multimedia-ad-bid-adjustment-setting';
import image from './multimedia-ad.svg';
import { getSummary, RANGE } from './util';

const isBidAdjustmentValid = data => validateBidAdjustment({
  value: data.bidAdjustmentInput,
  min: RANGE.min,
  max: RANGE.max,
}) === null;

export const MultimediaAdBidAdjustmentSection = ({
  onDataChange, data, level, expand, permissions, ...rest
}) => {
  const i18n = useContext(I18nContext);
  const [isValid, setIsValid] = useState(true);
  const onChange = useCallback((newData) => {
    const isDataValid = newData.multimediaAds.useParentLevel ? true : isBidAdjustmentValid(newData.multimediaAds.currentLevelData);
    onDataChange({ data: newData, isValid: isDataValid });
    setIsValid(isDataValid);
  }, [onDataChange]);

  if (!data || (permissions.IsDomesticSimplifiedChineseEnabled && !permissions.dynamic.MMAForCN)) {
    return null;
  }

  return (
    <ValidatedPanel
      key="multimedia-ad"
      title={<TextTitle
        titleKey={_TL_('Multimedia ads')}
        icon={image}
        topicKey="pop_BA_MMA_BidAdjustment"
        details={getSummary(level, data.multimediaAds, i18n)}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'multimedia-ad',
      }}
      error={isValid ? null : _TL_("* Something's wrong")}
      {...rest}
    >
      <MultimediaAdBidAdjustmentSettings
        onDataChange={onChange}
        data={data}
        level={level}
      />
    </ValidatedPanel>
  );
};

MultimediaAdBidAdjustmentSection.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  data: PropTypes.shape({
    multimediaAds: PropTypes.shape({}),
  }),
  level: PropTypes.string.isRequired,
  expand: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    IsDomesticSimplifiedChineseEnabled: PropTypes.bool,
    dynamic: PropTypes.shape({
      MMAForCN: PropTypes.bool,
    }),
  }).isRequired,
};

MultimediaAdBidAdjustmentSection.defaultProps = {
  data: null,
};
